import type { BreadcrumbItem } from '@ifixit/breadcrumbs';

/** The crumb shape the PHP nav components send. */
export interface BreadcrumbData {
   name: string;
   url: string;
}

export function toCrumbs(breadCrumbs: BreadcrumbData[]): BreadcrumbItem[] {
   return breadCrumbs.map(({ name, url }) => ({ label: name, url }));
}
